// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import storeTrainingSubscription from 'actions/training/subscription/store';
import indexTraining from 'actions/training/training/index';
import storeTraining from 'actions/training/training/store';
import Button from 'components/UI/Button/Button';
import LabelWrapper from 'components/UI/Label/LabelWrapper';
import Modal from 'components/UI/Modal/Modal';
import RichText from 'components/UI/RichText/RichText';
import { useAlert } from 'hooks/useAlert';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import React, { useState } from 'react';
import './TrainingModal.module.scss';
// =========================

export default function TrainingModal({
  training,
  categories,
}: // skills,
{
  training?: TrainingEntity;
  categories?: (CategoryEntity | undefined)[];
  // skills?: (SkillEntity | undefined)[];
}) {
  const userId = useRedux((state) => state.authentication?.user?.id);
  const translate = useTranslate();
  const dispatch = useReduxAction();
  const shouldJoin = usePermission(['Leerling', 'Leerling Portfolio']);
  const shouldClone = usePermission(['Docent', 'super-admin']);
  const alert = useAlert();

  const inMyCourses =
    useRedux((state) =>
      state?.training?.entities?.allIds
        ?.map((id) => state?.training?.entities?.byId[id])
        ?.filter((t) => t?.owner?.id === userId || t?.subscription_id)
        ?.find(
          (t) => t?.cloned_from_id === training?.id || t?.id === training?.id
        )
    ) !== undefined;

  const images = training?.attachments
    ?.filter((a) => a.attachment_type === 'image')
    .map((a) => JSON.parse(a.attachment_data).file_path);

  const lessonCount = training?.sessions?.reduce(
    (count, session) =>
      session.lessons ? count + session?.lessons?.length : 0,
    0
  );

  const [addingCourse, setAddingCourse] = useState(false);

  function handleClick() {
    if (shouldClone || shouldClone) setAddingCourse(true);

    if (shouldJoin)
      return dispatch(storeTrainingSubscription({ trainingId: training?.id }))
        .then(() => {
          setAddingCourse(false);
          return dispatch(indexTraining());
        })
        .catch(() => {
          setAddingCourse(false);
          alert(translate('course.errors.saving'));
        });

    if (shouldClone)
      return dispatch(storeTraining({ cloneFromId: training?.id }))
        .then(() => {
          setAddingCourse(false);
          return dispatch(indexTraining());
        })
        .catch(() => {
          setAddingCourse(false);
          alert(translate('course.errors.saving'));
        });
  }

  return (
    <Modal images={images} video={training?.youtube}>
      <div styleName="wrapper">
        <div>
          <h1>{training?.title}</h1>
          <div styleName="information">
            <p>
              {`${training?.owner?.first_name} ${training?.owner?.last_name}`}
            </p>
            {training?.sessions?.length ? (
              <p>
                {`${training?.sessions?.length} ${
                  training?.sessions?.length > 1
                    ? translate('course.terms.sessions')
                    : translate('course.terms.session')
                }`}
              </p>
            ) : null}
            {lessonCount ? (
              <p>
                {`${lessonCount} ${
                  lessonCount > 1
                    ? translate('course.terms.lessons')
                    : translate('course.terms.lesson')
                }`}
              </p>
            ) : null}
          </div>
        </div>
        <div styleName="button-wrapper">
          {inMyCourses ? (
            <Button color="green">
              {translate('general.terms.in-my-courses')}
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          ) : (
            <Button color="grey" onClick={handleClick} inactive={addingCourse}>
              {translate('course.actions.add-to-my-courses')}
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          )}
        </div>
        <div styleName="description">
          <p>{training?.description}</p>
          {training?.attachments
            ?.filter((a) => a.attachment_type === 'text')
            .sort((a, b) => (a.order_index || 0) - (b.order_index || 0))
            .map((a) => {
              const { title } = JSON.parse(a.attachment_data);
              const description = JSON.parse(a.attachment_data).text;

              return (
                <div key={a.id}>
                  <strong>{title}</strong> <RichText content={description} />
                </div>
              );
            })}
        </div>
        <div styleName="labels">
          <LabelWrapper
            title={translate('general.terms.categories')}
            labels={training?.categories?.map(
              (cat) =>
                categories?.find((c) => c?.id === cat.category_id)?.name || ''
            )}
          />
          {/* <LabelWrapper
            title={translate('general.terms.skills')}
            labels={training?.skills?.map(
              (skill) => skills?.find((s) => s?.id === skill.id)?.name || ''
            )}
          /> */}
        </div>
      </div>
    </Modal>
  );
}
